import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/laporan/daftar-nasabah",
    url_path: "/laporan/daftar-nasabah",
  },
];
